import { gql, TypedDocumentNode } from '@apollo/client';

import { IGetTamarinProjectQueryGraphQLResponse, IGetTamarinProjectQueryVariables } from './useGetTamarinProject.interfaces';

const GET_TAMARIN_PROJECT_QUERY = gql`
  query getTamarinProject($id: String!) {
    project {
      getTamarinProject: get(id: $id) {
        id
        isActive
        name
        remainingScans
      }
    }
  }
` as TypedDocumentNode<
  IGetTamarinProjectQueryGraphQLResponse,
  IGetTamarinProjectQueryVariables
>;

export { GET_TAMARIN_PROJECT_QUERY };
